"use strict";

import {
    QA_REVIEW_RETURN,
    QA_REVIEW_START,
    QA_REVIEW_SUBMIT,
    QA_REVIEWS,
} from "../../ApiEndpoints";
import {
    getWithFirebaseAuth,
    postWithFirebaseAuth,
} from "../../utils/firebaseApiClient";

// The backend identifies the reviewer from the Firebase token.
export const startQAReview = (projectId, language) => (
    postWithFirebaseAuth(QA_REVIEW_START, { projectId, language })
);

export const submitQAReview = (projectId, language) => (
    postWithFirebaseAuth(QA_REVIEW_SUBMIT, { projectId, language })
);

export const returnQAReview = ({ projectId, language, userId, note }) => (
    postWithFirebaseAuth(QA_REVIEW_RETURN, { projectId, language, userId, note })
);

export const getQAReviews = (projectId) => (
    getWithFirebaseAuth(`${QA_REVIEWS}/${encodeURIComponent(projectId)}`)
);
